import type { ReactNode } from 'react';
import type { IAuthorization } from '~/domain/Credentials/types/Credentials';
import type { IJob, IUser } from '~/models';
import { BookedProfessionalPanel } from '../../BookedProfessionalPanel';

export interface ICompletedProfessionalPanelProps {
  job: IJob;
  /**
   * The professional's full profile, once it has loaded. Until it lands this is
   * `null` and only the topper renders.
   */
  professional: IUser | null;
  /** Verified credentials for the Credentials tab. */
  authorizations?: IAuthorization[] | null;
  /** The topper's `⋯` menu — favourite and block, when the shift still offers them. */
  overflowMenu?: ReactNode;
  /** Whether the shell has stacked its columns; only `CandidateDetails` needs telling. */
  isCollapsed?: boolean;
}

/**
 * The primary column of the COMPLETED page: who worked the shift, and their
 * profile.
 *
 * The card itself is the shared {@link BookedProfessionalPanel} — the Figma draws
 * one for the scheduled, completed and cancelled frames alike, with no rule
 * between the topper and the profile on any of them. All this fixes is what makes
 * the completed page's copy of it *the completed page's*: the `complete-cancelled`
 * topper style, and the fact that its controls arrive as a `⋯` menu rather than as
 * buttons. Every action a completed shift offers acts on the professional, so a
 * menu is the right slot; the scheduled page hands its *Message Professional*
 * button to `actions` instead.
 */
export const CompletedProfessionalPanel = ({
  job,
  professional,
  authorizations,
  overflowMenu,
  isCollapsed = false,
}: ICompletedProfessionalPanelProps) => (
  <BookedProfessionalPanel
    job={job}
    professional={professional}
    authorizations={authorizations}
    topperStyle="complete-cancelled"
    overflowMenu={overflowMenu}
    testIDPrefix="completed"
    isCollapsed={isCollapsed}
  />
);
